import type { ComponentProps } from "react"
import { useState } from "react"
import { HugeiconsIcon } from "@hugeicons/react"
import { ViewIcon, ViewOffSlashIcon } from "@hugeicons/core-free-icons"
import { InputGroupButton } from "@motleyhand/design"
import FormInput from "./FormInput"

type Props = Omit<
  ComponentProps<typeof FormInput>,
  "inputMode" | "icon" | "required" | "autoComplete"
> & {
  readonly isNewPassword: boolean
}

export default function FormPasswordField({ isNewPassword, ...props }: Props) {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <FormInput
      {...props}
      type={showPassword ? "text" : "password"}
      autoComplete={isNewPassword ? "new-password" : undefined}
      icon={
        <InputGroupButton
          size="icon-xs"
          variant="ghost"
          aria-label={showPassword ? "Hide password" : "Show password"}
          onClick={handleClickShowPassword}
        >
          <HugeiconsIcon
            icon={showPassword ? ViewOffSlashIcon : ViewIcon}
            strokeWidth={2}
          />
        </InputGroupButton>
      }
      required
    />
  )
}
